<template>
  <div>
    <div class="content-body">
      <div class="row">
        
        <div class="col-xl-4 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <img :src="$store.getters.getProfilePhoto" class="card-img-top img-fluid"/>
              
              <div class="card-block">
                <h4 class="card-title">{{user.name}}</h4>

                <center>
                  <input type="file" name="file" id="file" class="inputfile" accept="image/*" @change="onUploadImg"/>
                  <label id="file_loader" for="file">
                    <a class="btn btn-warning btn-min-width" role="button"><i class="icon-upload3"></i> {{$t('profile.buttons.photo')}}</a>
                  </label>
                </center>
                <!--<p class="card-text">Some quick example text to build on the card content.</p>-->
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-block">
                <form class="form">
                  <div class="form-body">
                    <h4 class="form-section"><i class="icon-eye6"></i> {{$t('profile.titles.aboutUsr')}}</h4>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="login">{{$t('users.table.login')}}</label>
                          <input type="text" id="login" class="form-control border-primary" v-model="user.login" name="login">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="name">{{$t('users.table.name')}}</label>
                          <input type="text" id="name" class="form-control border-primary" v-model="user.name" name="name">
                        </div>
                      </div>
                      
                      <div v-if="changePass" class="px-1"  >
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="pass1">{{$t('profile.table.oldPass')}}</label>
                              <input type="password" id="pass1" class="form-control border-primary" v-model="user.password" name="pass1">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 " >
                          <div class="form-group">
                            <label for="pass2">{{$t('profile.table.newPass')}}</label>
                            <input type="password" id="passNew" class="form-control border-primary" v-model="user.newPassword" name="passNew">
                          </div>
                        </div>
                        <div class="col-md-6"> 
                          <div class="form-group">
                            <label for="passNew">{{$t('profile.table.oldPass2')}}</label>
                            <input type="password" id="pass2" class="form-control border-primary" v-model="user.newPassword2" name="pass2">
                          </div>
                        </div>
                        </div>
                                         
                      
                      </div>
                      
                      <div class="col-md-12">
                          <div style="display: flex; flex-direction: row; justify-content: center; margin-top: 5px;">
                              <div class="btn-group">
                                <button v-if="!changePass" type="button" class=" w-100 btn btn-warning" @click="changePass = true">
                                  <i class="icon-pencil22"></i> {{$t('profile.buttons.chnPass')}}
                                </button>
                                <button v-if="changePass" @click="changePassword()" type="button" class="btn btn-primary">
                                  <i class="icon-check2"></i> {{$t('profile.buttons.save')}}
                                </button>
                                <button v-if="changePass" @click="changePass = false" type="button" class="btn btn-warning">
                                  <i class="icon-cross"></i> {{$t('equipm.buttons.cancel')}}
                                </button>
                              </div>
                          </div>
                      </div>

                    </div>

                    <h4 class="form-section"><i class="icon-mail6"></i> {{$t('profile.titles.contact')}}</h4>

                    <div class="form-group">
                      <label for="email">{{$t('users.table.email')}}</label>
                      <input class="form-control border-primary" v-model="user.email" type="email" placeholder="email" id="email">
                    </div>

                    <div class="form-group">
                      <label for="city">{{ $t('profile.table.city')}}</label>
                      <input class="form-control border-primary" v-model="user.frontOffice" type="text" id="city" name="city">
                    </div>

                    <div class="form-group">
                      <label for="nameCl">{{$t('users.table.nameClient')}}</label>
                      <input class="form-control border-primary" type="text" v-model="user.organization" id="nameCl" name="nameCl" disabled>
                    </div>

                    <div class="form-group">
                      <label for="telephone">{{$t('users.table.phone')}}</label>
                      <input class="form-control border-primary" type="text" v-model="user.tel" id="telephone" name="telephone">
                    </div>

                    <!--<div class="form-group">
                      <label for="userinput8">Some extra info</label>
                      <textarea id="userinput8" rows="5" class="form-control border-primary" name="bio" placeholder="Bio"></textarea>
                    </div>-->

                  </div>
                  <div class="form-group" v-if="userRole == 'admin' || userRole == 'logist' || userRole == 'client'">
                    <fieldset  class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': this.error.typeOfdelivery }">
                        <label class="label text-bold-600"> Вид перевезення </label>  
                      </fieldset>
                      <fieldset  class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': this.error.typeOfdelivery }">  
                                                
                        <label class="label">
                          <input type="checkbox" value="true" v-model="user.typeOfdelivery.auto">
                          Авто
                        </label> 
                        <label class="label">
                          <input type="checkbox" value="true" v-model="user.typeOfdelivery.jd">
                          Залізничні перевезення
                        </label>   
                        <label class="label">
                          <input type="checkbox" value="true" v-model="user.typeOfdelivery.avia">
                          Авіа
                        </label>                      
                        <label class="label">
                          <input type="checkbox" value="true" v-model="user.typeOfdelivery.sea">
                          Морські
                        </label>                      
                      </fieldset>
                      <fieldset  class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': this.error.directionOfdelivery }">
                        <label class="label text-bold-600"> Напрямок перевезення </label>  
                      </fieldset>
                        <fieldset  class="form-group position-relative checkboxsas mb-otstup" :class="{ 'form-group--error': this.error.directionOfdelivery }">                                                       
                        <label class="label">
                          <input type="checkbox" value="1" v-model="user.directionOfdelivery.internal">
                          Внутрішні
                        </label> 
                        <label class="label">
                          <input type="checkbox" value="2" v-model="user.directionOfdelivery.exsternal">
                          Експорт
                        </label>
                                              
                      </fieldset>
                  </div>

                  <div class="form-actions center">
                    <!--<button type="button" class="btn btn-warning mr-1">
                      <i class="icon-cross2"></i> Cancel
                    </button>-->
                    <button type="button" class="btn btn-primary" @click="saveProfile">
                      <i class="icon-check2"></i> {{$t('profile.buttons.save')}}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Profile",
    components: {},
    data() {
      return {
        changePass: false,
        user:{
          login:'',
          name:'',
          email:'',
          tel:'',
          organization:'',
          frontOffice:'',
          photo: null,
          password: '',
          password2: '',
          newPassword: '',
          typeOfdelivery:{
                auto:false,
                jd:false,
                avia:false,
                sea:false
              },
          directionOfdelivery:{
            internal:false,
            exsternal:false
          }
        },
        error:{
          directionOfdelivery: false,
          typeOfdelivery:false
        }
      }
    },
    computed:{
      userRole(){
        if(this.$store.getters.getUserRoleAdmin){
            return  "admin"    
        }
        else if (this.$store.getters.getUserRoleLogist) {             
          return "logist"
        }
        else if (this.$store.getters.getUserRoleClient) {             
          return "client"
        }
        else return "user"      
      },
    },
    mounted() {
      this.checkAuthorized();
      this.getDataProfile();
    },
    methods: {
      getDataProfile() {
        this.makeQuery("/drawing/getDataProfile", { session: this.$store.state.userToken, system: "1"})
        .then(res => {
            if(res != null){
              this.user.login = res.data.login;
              this.user.name = res.data.name;
              this.user.email = res.data.email;
              this.user.tel = res.data.tel;
              this.user.organization = res.data.organization;
              this.user.frontOffice  = res.data.frontOffice;
              this.user.typeOfdelivery = res.data.typeOfdelivery;
              this.user.directionOfdelivery = res.data.directionOfdelivery;
              //this.$store.state.profilePhoto = "data:image/jpg;base64," + res.data.image;
            }
        });

      },

      saveProfile(){
        if(this.changePass &&
          ((this.user.password != this.user.password2) 
            || ((this.user.password2.length > 1) && (this.user.newPassword == ''))
          )
        ){
          this.showNotification('custom-error','Error',this.$t('errors.passComp'));
          return
        }
        if(!this.user.directionOfdelivery.internal && !this.user.directionOfdelivery.exsternal){
          this.error.directionOfdelivery = true
           this.showNotification('custom-error','Error',this.$t('errors.required'));
          return 
        }
        else this.error.directionOfdelivery = false
        if(!this.user.typeOfdelivery.auto && !this.user.typeOfdelivery.jd && !this.user.typeOfdelivery.avia && !this.user.typeOfdelivery.sea){
          this.error.typeOfdelivery = true
           this.showNotification('custom-error','Error',this.$t('errors.required'));
          return 
        }
        else this.error.typeOfdelivery = false
        this.makeQuery("/drawing/saveProfile", {
          session: this.$store.state.userToken,
          user: {
            login: this.user.login,
            name: this.user.name,
            email: this.user.email,
            tel: this.user.tel,
            organization: this.user.organization,
            frontOffice: this.user.frontOffice,
            photo: this.user.photo, 
            typeOfdelivery:this.user.typeOfdelivery,
            directionOfdelivery:this.user.directionOfdelivery,
            system: "1"

          },
          oldPassword: this.user.password,
          newPassword: this.user.newPassword,            
        })
        .then(res => {
            if(res != null){
              this.changePass = false;
                this.showNotification('custom-success','Profile',"Changes saved.");
                this.getDataProfile()
            }
        });
      },
      changePassword(){
        this.user.password = this.user.password.trim();
        this.user.newPassword = this.user.newPassword.trim();
        this.user.newPassword2 = this.user.newPassword2.trim();


        if(this.user.newPassword2 != this.user.newPassword){
          this.showNotification('custom-error','Error',this.$t('errors.passComp'));
          return
        }
        if(this.user.newPassword.length < 6){
          this.showNotification('custom-error','Error',this.$t('errors.passLeng'));
          return
        }
        if(this.user.password.length < 1){
          this.showNotification('custom-error','Error',this.$t('errors.passFill'));
          return
        }
        this.makeQuery("/service/changePasswordService", {
          token: this.$store.getters.getUserToken,
          dataRequest: { oldPassword: this.user.password, newPassword: this.user.newPassword}
        })
        .then(res => {
            if(res != null && res.data.result){
              this.changePass = false;
                this.showNotification('custom-success','Profile',"Changes saved.");
                this.user.newPassword2 = null;
                this.user.newPassword = null;
                this.user.password = null;
            }
            else {
              this.showNotification('custom-error','Error',res.data.data);
            }
        });


      },
      onUploadImg(e){
        let tt;
        const element = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(element);
        reader.onload = e => {
          tt = (e.target.result).split(',');
            this.user.photo = { name: element.name, data: tt[1] };
            localStorage.setItem('profileImg', e.target.result);
            localStorage.setItem('profileTime', Date.now());
            this.$store.commit('setProfilePhoto',e.target.result);

        };
      },

    }

  }
</script>

<style scoped>
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
#file_loader {
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
	cursor: pointer;
}
.form-group__message, .error {
    font-size: 0.75rem;
    line-height: 1;
    display: none;
    /* margin-left: 14px; */
    margin-top: 0.6875rem;
    margin-bottom: 0.9375rem; }
.form-group--alert,
  .form-group--error {
    animation-name: shakeError;
    animation-fill-mode: forwards;
    animation-duration: .6s;
    animation-timing-function: ease-in-out; 
    
    }
  
    .form-group--success .form__label, .form-group--success .form__label--inline {
    color: #43AC6A; }
  
  .form-group--success .form-group__addon {
    color: white;
    border-color: #85d0a1;
    background: #85d0a1; }
  
  .form-group--success input,
  .form-group--success textarea,
  .form-group--success input:focus,
  .form-group--success input:hover {
    border-color: #85d0a1; }
  
  .form-group--success + .form-group__message, .form-group--success + .error {
    display: block;
    color: #73c893; }
  
  .form-group--error .form__label, .form-group--error .form__label--inline, .form-group--error .label {
    color: #f04124; }
  
  .form-group--error .form-group__addon {
    color: white;
    border-color: #f79483;
    background: #f79483; }
  
  .form-group--error input,
  .form-group--error textarea,
  .form-group--error input:focus,
  .form-group--error input:hover {
    border-color: #f79483; }
  
  .form-group--error  .form-group__message, .form-group--error .error {
    display: block;
    color: #f57f6c; }
  
  .form-group--alert .form__label, .form-group--alert .form__label--inline {
    color: #f08a24; }
  
  .form-group--alert .form-group__addon {
    color: white;
    border-color: #f7bd83;
    background: #f7bd83; }
  
  .form-group--alert input,
  .form-group--alert textarea,
  .form-group--alert input:focus,
  .form-group--alert input:hover {
    border-color: #f7bd83; }
  
  .form-group--alert + .form-group__message {
    display: block;
    color: #f5b06c; }
</style> 



// WEBPACK FOOTER //
// src/pages/Profile.vue